// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-month {
  display: grid;
  grid-template-columns: repeat(7, 36px);
  grid-auto-rows: 36px;
  grid-gap: 4px;
  justify-content: center;
  margin-bottom: 5px;
}
.dl-datepicker-month__day {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  cursor: pointer;
}
.dl-datepicker_desktop .dl-datepicker-month__day:hover {
  background-color: var(--g-color-base-simple-hover);
}
.dl-datepicker-month__day_weekend {
  color: var(--g-color-text-danger);
}
.dl-datepicker-month__day_today {
  color: var(--g-color-text-info);
}
.dl-datepicker-month__day_selected {
  border-radius: 0;
  background-color: var(--g-color-base-selection);
}
.dl-datepicker_desktop .dl-datepicker-month__day_selected:hover {
  background-color: var(--g-color-base-selection);
}
.dl-datepicker-month__day_right-edge {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dl-datepicker-month__day_selected:not(.dl-datepicker-month__day_left-edge)::before {
  content: "";
  position: absolute;
  top: 0;
  left: -4px;
  display: block;
  height: 36px;
  width: 4px;
  background-color: var(--g-color-base-selection);
}
.dl-datepicker-month__day_left-edge, .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected) + .dl-datepicker-month__day_selected {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dl-datepicker-month__day_left-edge::before, .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected) + .dl-datepicker-month__day_selected::before {
  height: 0;
}
.dl-datepicker-month__day_selected + .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected):not(.dl-datepicker-month__day_left-edge)::before {
  content: "";
  position: absolute;
  top: 0;
  left: -8px;
  display: block;
  height: 36px;
  width: 4px;
  background-color: var(--g-color-base-float);
  pointer-events: none;
}
.dl-datepicker-month__day_selected + .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected):not(.dl-datepicker-month__day_left-edge)::after {
  content: "";
  position: absolute;
  top: 0;
  left: -8px;
  display: block;
  height: 36px;
  width: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: var(--g-color-base-selection);
  pointer-events: none;
}
.dl-datepicker-month__day_disabled {
  opacity: 0.3;
  pointer-events: none;
}
.dl-datepicker-month__title {
  grid-area: title;
  align-self: center;
  font-size: 18px;
  line-height: 20px;
  color: var(--g-color-text-secondary);
}
.dl-datepicker-month__title_disabled {
  opacity: 0.3;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/Month/Month.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sCAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACR;AACQ;EACI,kDAAA;AACZ;AAEQ;EACI,iCAAA;AAAZ;AAGQ;EACI,+BAAA;AADZ;AAIQ;EACI,gBAAA;EACA,+CAAA;AAFZ;AAIY;EACI,+CAAA;AAFhB;AAMQ;EACI,4BAAA;EACA,+BAAA;AAJZ;AAOQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;AALZ;AAQQ;EAEI,2BAAA;EACA,8BAAA;AAPZ;AASY;EACI,SAAA;AAPhB;AAYY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,2CAAA;EACA,oBAAA;AAVhB;AAaY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,+BAAA;EACA,+CAAA;EACA,oBAAA;AAXhB;AAeQ;EACI,YAAA;EACA,oBAAA;AAbZ;AAiBI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;AAfR;AAiBQ;EACI,YAAA;EACA,oBAAA;AAfZ","sourcesContent":[".dl-datepicker-month {\n  display: grid;\n  grid-template-columns: repeat(7, 36px);\n  grid-auto-rows: 36px;\n  grid-gap: 4px;\n  justify-content: center;\n  margin-bottom: 5px;\n}\n.dl-datepicker-month__day {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.dl-datepicker_desktop .dl-datepicker-month__day:hover {\n  background-color: var(--g-color-base-simple-hover);\n}\n.dl-datepicker-month__day_weekend {\n  color: var(--g-color-text-danger);\n}\n.dl-datepicker-month__day_today {\n  color: var(--g-color-text-info);\n}\n.dl-datepicker-month__day_selected {\n  border-radius: 0;\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker_desktop .dl-datepicker-month__day_selected:hover {\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker-month__day_right-edge {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.dl-datepicker-month__day_selected:not(.dl-datepicker-month__day_left-edge)::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -4px;\n  display: block;\n  height: 36px;\n  width: 4px;\n  background-color: var(--g-color-base-selection);\n}\n.dl-datepicker-month__day_left-edge, .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected) + .dl-datepicker-month__day_selected {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.dl-datepicker-month__day_left-edge::before, .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected) + .dl-datepicker-month__day_selected::before {\n  height: 0;\n}\n.dl-datepicker-month__day_selected + .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected):not(.dl-datepicker-month__day_left-edge)::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -8px;\n  display: block;\n  height: 36px;\n  width: 4px;\n  background-color: var(--g-color-base-float);\n  pointer-events: none;\n}\n.dl-datepicker-month__day_selected + .dl-datepicker-month__day:not(.dl-datepicker-month__day_selected):not(.dl-datepicker-month__day_left-edge)::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -8px;\n  display: block;\n  height: 36px;\n  width: 4px;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: var(--g-color-base-selection);\n  pointer-events: none;\n}\n.dl-datepicker-month__day_disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n.dl-datepicker-month__title {\n  grid-area: title;\n  align-self: center;\n  font-size: 18px;\n  line-height: 20px;\n  color: var(--g-color-text-secondary);\n}\n.dl-datepicker-month__title_disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
